const STORAGE_KEY = "resonella.reportedHidden";

/** Scene ids the user has reported and chosen to hide from their own Community feed (local to this device). */
export function hiddenReportedIds(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      return new Set<string>();
    }
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return new Set<string>();
    }
    return new Set<string>(parsed.filter((x: unknown): x is string => typeof x === "string"));
  } catch {
    return new Set<string>();
  }
}

export function hideReported(id: string): void {
  const set = hiddenReportedIds();
  set.add(id);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(set)));
  } catch {
    // quota/private-mode write failure is ignored: hiding is best-effort local state
  }
}
